import { __extends } from "tslib";
import { UpdateSmsChannelRequest, UpdateSmsChannelResponse } from "../models/models_1";
import { deserializeAws_restJson1UpdateSmsChannelCommand, serializeAws_restJson1UpdateSmsChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateSmsChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateSmsChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateSmsChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateSmsChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "UpdateSmsChannelCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: UpdateSmsChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateSmsChannelResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateSmsChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateSmsChannelCommand(input, context);
    };
    UpdateSmsChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateSmsChannelCommand(output, context);
    };
    return UpdateSmsChannelCommand;
}($Command));
export { UpdateSmsChannelCommand };
//# sourceMappingURL=UpdateSmsChannelCommand.js.map